import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { SimpleCallback } from 'platform-components';

import { PersonalDataModalStore } from './typings';

const initialState: PersonalDataModalStore = {
    acceptPersonalDataStatus: LOADING_STATUSES.UNSENT,
    wasShown: false,
};

const slice = createSlice({
    name: 'PERSONAL_DATA_MODAL',
    initialState: initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        acceptPersonalDataRequest: (state, action: PayloadAction<{ onSuccess: SimpleCallback } | undefined>) => {
            state.acceptPersonalDataStatus = LOADING_STATUSES.LOADING; // action params for saga
        },
        acceptPersonalDataSuccess: (state) => {
            state.acceptPersonalDataStatus = LOADING_STATUSES.SUCCESS;
        },
        acceptPersonalDataError: (state) => {
            state.acceptPersonalDataStatus = LOADING_STATUSES.ERROR;
        },
    },
});

export const personalDataModalActions = slice.actions;
export const personalDataModalReducer = slice.reducer;
